export function initIntersectionObserver(): void {
  // Only run if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    return;
  }

  // Fade in animation for elements
  const observerOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe sections and cards
  const elementsToObserve = document.querySelectorAll(
    'section, .service-card, .review-card, .result-card, .faq__item'
  );

  elementsToObserve.forEach((element) => {
    // Set initial opacity for animation
    // (element as HTMLElement).style.opacity = '0';
    // (element as HTMLElement).style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
    observer.observe(element);
  });
}
